// Tekst koji se popuni tek pri fizičkom potpisu. Ne ostavljamo prazan string
// jer bi rečenica "Terapeut , sa adresom ," izgledala kao greška umjesto kao
// mjesto za popunjavanje.
export const BLANK = "__________";

/**
 * Zamijeni placeholder atome njihovim vrijednostima; neriješen ili prazan postaje
 * prazna linija. Čist modul: koristi ga server i onboarding, koji ugovor popunjava
 * uživo iz podataka koje terapeut upravo kuca.
 */
export function fillPlaceholders(node: unknown, values: Record<string, string>): unknown {
  if (Array.isArray(node)) return node.map((n) => fillPlaceholders(n, values));
  if (!node || typeof node !== "object") return node;

  const n = node as { type?: string; attrs?: { key?: string }; content?: unknown[]; marks?: unknown[] };
  if (n.type === "placeholder") {
    const value = values[n.attrs?.key ?? ""] ?? "";
    return { type: "text", text: value.length > 0 ? value : BLANK, ...(n.marks ? { marks: n.marks } : {}) };
  }
  if (Array.isArray(n.content)) {
    return { ...n, content: n.content.map((c) => fillPlaceholders(c, values)) };
  }
  return node;
}
